import {RouterModule} from '@angular/router';
import {CompanySharedModule} from '../company/components/shared/company-shared.module';
import {ContractSharedModule} from '../bonding-contract/contract/components/shared/contract-shared.module';
import {NgModule} from '@angular/core';
import {SharedComponentsModule} from '../../bonding_shared/components/shared-components.module';
import {BrowserModule} from '@angular/platform-browser';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {BusinessObjectInfoComponent} from './business-object-info.component';

@NgModule({
  imports: [
    RouterModule,
    BrowserModule,
    SharedComponentsModule,
    FormsModule,
    ReactiveFormsModule,
    CompanySharedModule,
    ContractSharedModule,
  ],
  declarations: [BusinessObjectInfoComponent],
  exports: [BusinessObjectInfoComponent],
  providers: [],
})
export class BusinessObjectInfoModule {}
